import { useQueryClient } from '@tanstack/react-query'
import debounce from 'lodash/debounce'
import { useCallback, useEffect, useMemo } from 'react'
import { RequestDetailsQueryKey } from '@omnea-app/fe-requests/useRequestDetail'
import { taskQueryKeys } from '@omnea-app/fe-tasks/queryKeys'

const DEBOUNCE_TIME = 1000

export const useInvalidateRequestsAndTasksQueries = () => {
  const queryClient = useQueryClient()

  const invalidateQueries = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: taskQueryKeys.all })
    void queryClient.invalidateQueries({
      queryKey: [RequestDetailsQueryKey],
    })
    void queryClient.invalidateQueries({
      queryKey: ['dashboard-requests'],
    })
    void queryClient.invalidateQueries({
      queryKey: ['dashboard-requests-stats'],
    })
  }, [queryClient])

  const debouncedInvalidateQueries = useMemo(() => debounce(invalidateQueries, DEBOUNCE_TIME), [invalidateQueries])

  useEffect(() => {
    return () => {
      debouncedInvalidateQueries.cancel()
    }
  }, [debouncedInvalidateQueries])

  return debouncedInvalidateQueries
}
